import { render, staticRenderFns } from "./detailSection.vue?vue&type=template&id=94217b98&scoped=true&"
import script from "./detailSection.vue?vue&type=script&lang=js&"
export * from "./detailSection.vue?vue&type=script&lang=js&"
import style0 from "./detailSection.vue?vue&type=style&index=0&id=94217b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94217b98",
  null
  
)

export default component.exports